import { render } from "./P005.vue?vue&type=template&id=0567b504&scoped=true"
import script from "./P005.vue?vue&type=script&lang=js"
export * from "./P005.vue?vue&type=script&lang=js"

import "./P005.vue?vue&type=style&index=0&id=0567b504&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0567b504"]])

export default __exports__